import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  tabTitle: {
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: '1em',
    color: '#2C2D3E',
    marginBottom: '30px',
  },
  subTitle: {
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: '0.9em',
    color: '#2C2D3E',
    padding: '5px 15px',
    marginBottom: '10px',
  },
  tableRow: {
    marginBottom: '20px',
  },
  buttonLink: {
    color: '#3C419A',
    textDecoration: 'underline',
    fontWeight: 'bold',
    fontFamily: 'Roboto',
    fontSize: '1rem',
    cursor: 'pointer',
    background: 'none',
    border: 'none',
    padding: '0px'
  },
}));